/**
 * 学习乐园 · 七桥一笔画（game-yibihua.js）
 * ============================================================
 * 「逻辑与推理」组新作：入门（2 奇点图，默认档）、进阶（2 奇点更多桥）、
 * 挑战（0 奇点欧拉回路，须回到起点）。规则：从起点出发，每座桥恰好走
 * 一次，把所有桥走完。
 *
 * 反馈口径：点不相邻的点讲「没有桥」；走已走的桥讲「每座桥恰好一次」；
 * 走进死路当场讲「卡住了」并给配对口诀。查一查讲奇点定理本身（数每点
 * 桥数，奇数条为奇点：0 个任意出发回起点、2 个从其一走到另一、其余无解），
 * 再对当前局面算剩余图奇点。撤销随时可用，卡住不是惩罚。
 * 成绩口径：不计时，只按档位记完成局数，存本机 localStorage。
 *
 * 冒烟钩子：window.STYibihua 暴露 degrees / oddVerts / remainingOdd /
 * eulerOk 与 state()（{graph, cur, start, walked, needBack}）。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-yibihua';
  var RECORD_KEY = 'study-yibihua-record';

  /* ============ 引擎：纯函数 ============ */

  function degrees(g) {
    var d = new Array(g.V.length).fill(0);
    for (var i = 0; i < g.E.length; i++) { d[g.E[i][0]]++; d[g.E[i][1]]++; }
    return d;
  }

  function oddVerts(g) {
    var d = degrees(g), out = [];
    for (var i = 0; i < d.length; i++) { if (d[i] % 2 === 1) out.push(i); }
    return out;
  }

  function eulerOk(g) { return oddVerts(g).length <= 2; }

  // 剩余图（删掉已走边）里某点的度
  function remainingDeg(g, walked, v) {
    var d = 0;
    for (var i = 0; i < g.E.length; i++) {
      if (walked[i]) continue;
      if (g.E[i][0] === v || g.E[i][1] === v) d++;
    }
    return d;
  }

  function remainingOdd(g, walked) {
    var out = [];
    for (var v = 0; v < g.V.length; v++) {
      if (remainingDeg(g, walked, v) % 2 === 1) out.push(v);
    }
    return out;
  }

  /* ============ 图库（坐标 0~100；入门/进阶 2 奇点，挑战 0 奇点） ============ */

  var GRAPHS = [
    [
      { name: '五边形加两桥', start: 2, back: false,
        V: [[50, 6], [90, 36], [75, 84], [25, 84], [10, 36]],
        E: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 0], [0, 2], [0, 3]] },
      { name: '方块加天线', start: 0, back: false,
        V: [[25, 40], [75, 40], [75, 85], [25, 85], [50, 8]],
        E: [[0, 1], [1, 2], [2, 3], [3, 0], [4, 0], [4, 1]] }
    ],
    [
      { name: '六边形双桥', start: 2, back: false,
        V: [[50, 5], [88, 28], [88, 72], [50, 95], [12, 72], [12, 28]],
        E: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [0, 3], [0, 2]] },
      { name: '双环一弦', start: 1, back: false,
        V: [[42, 45], [15, 30], [10, 70], [45, 88], [85, 30], [90, 70], [58, 88]],
        E: [[0, 1], [1, 2], [2, 3], [3, 0], [0, 4], [4, 5], [5, 6], [6, 0], [1, 4]] }
    ],
    [
      { name: '六边形三角弦', start: 0, back: true,
        V: [[50, 5], [88, 28], [88, 72], [50, 95], [12, 72], [12, 28]],
        E: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [0, 2], [2, 4], [4, 0]] },
      { name: '双环共享港', start: 0, back: true,
        V: [[42, 45], [15, 30], [10, 70], [45, 88], [85, 30], [90, 70], [58, 88]],
        E: [[0, 1], [1, 2], [2, 3], [3, 0], [0, 4], [4, 5], [5, 6], [6, 0]] }
    ]
  ];

  /* ============ UI ============ */

  var LEVELS = [
    { name: '入门', hint: '2 个奇点 · 默认档' },
    { name: '进阶', hint: '桥更多 · 2 个奇点' },
    { name: '挑战', hint: '0 个奇点 · 回起点' }
  ];

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var NS = 'http://www.w3.org/2000/svg';
  function svgEl(tag, attrs) {
    var node = document.createElementNS(NS, tag);
    for (var k in attrs) node.setAttribute(k, attrs[k]);
    return node;
  }

  var root = null;
  var ui = {};
  var S = {
    level: 0, graph: null, cur: -1, start: -1,
    walked: [], path: [], needBack: false,
    ended: false, soundOn: true, resetArm: false, resetTimer: null
  };

  function renderLevels() {
    var box = ui.levels;
    box.textContent = '';
    for (var i = 0; i < LEVELS.length; i++) {
      (function (lv, li) {
        var b = el('button', 'st-llk-pack-btn');
        b.type = 'button';
        b.setAttribute('data-level', String(li));
        b.setAttribute('role', 'radio');
        b.appendChild(el('span', 'st-llk-pack-name', lv.name));
        b.appendChild(el('small', 'st-llk-pack-hint', lv.hint));
        b.addEventListener('click', function () {
          if (S.level === li) return;
          newGame(li);
        });
        box.appendChild(b);
      })(LEVELS[i], i);
    }
  }

  function syncLevels() {
    var btns = ui.levels.querySelectorAll('[data-level]');
    for (var i = 0; i < btns.length; i++) {
      var on = Number(btns[i].getAttribute('data-level')) === S.level;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function edgeIndex(a, b) {
    for (var i = 0; i < S.graph.E.length; i++) {
      var e = S.graph.E[i];
      if ((e[0] === a && e[1] === b) || (e[0] === b && e[1] === a)) return i;
    }
    return -1;
  }

  function buildBoard() {
    var svg = ui.svg;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 100 100');
    var g = S.graph;
    for (var i = 0; i < g.E.length; i++) {
      var e = g.E[i], p1 = g.V[e[0]], p2 = g.V[e[1]];
      svg.appendChild(svgEl('line', {
        x1: p1[0], y1: p1[1], x2: p2[0], y2: p2[1],
        'class': 'st-yb-edge', 'data-edge': String(i)
      }));
    }
    for (var v = 0; v < g.V.length; v++) {
      (function (vi) {
        var p = g.V[vi];
        var cg = svgEl('g', { 'class': 'st-yb-vert', 'data-vert': String(vi) });
        cg.appendChild(svgEl('circle', { cx: p[0], cy: p[1], r: 7 }));
        var t = svgEl('text', { x: p[0], y: p[1] + 2.6, 'text-anchor': 'middle' });
        t.textContent = String(vi + 1);
        cg.appendChild(t);
        cg.addEventListener('click', function () { onVert(vi); });
        svg.appendChild(cg);
      })(v);
    }
    renderBoard();
  }

  function renderBoard() {
    var g = S.graph;
    var edges = ui.svg.querySelectorAll('.st-yb-edge');
    for (var i = 0; i < edges.length; i++) {
      edges[i].classList.toggle('is-walked', !!S.walked[Number(edges[i].getAttribute('data-edge'))]);
    }
    var verts = ui.svg.querySelectorAll('.st-yb-vert');
    for (var k = 0; k < verts.length; k++) {
      var vi = Number(verts[k].getAttribute('data-vert'));
      verts[k].classList.toggle('is-cur', S.cur === vi);
      verts[k].classList.toggle('is-start', S.start === vi);
      verts[k].classList.toggle('is-dead', S.cur === vi && !S.ended
        && remainingDeg(g, S.walked, vi) === 0 && S.walked.filter(Boolean).length < g.E.length);
    }
    renderStatus();
  }

  function renderStatus() {
    if (S.ended) return;
    var done = S.walked.filter(Boolean).length;
    ui.status.className = 'st-status';
    ui.status.textContent = LEVELS[S.level].name + '「' + S.graph.name + '」· 已走 ' + done + '/' + S.graph.E.length
      + ' 座桥 · ' + (S.needBack ? '走完要回到起点' : '从 ' + (S.start + 1) + ' 号点出发');
  }

  function renderNote(text, tone) {
    ui.note.textContent = text || '';
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    for (var i = 0; i < LEVELS.length; i++) {
      var r = rec['x' + i];
      box.appendChild(recordStat(
        LEVELS[i].name + '档完成',
        (r && r.wins ? r.wins + ' 局' : '还没一笔画通过——走完全部桥就记在这里')
      ));
    }
  }

  function recordStat(label, value) {
    var d = el('div', 'st-llk-stat');
    d.appendChild(el('span', 'st-llk-stat-label', label));
    d.appendChild(el('strong', 'st-llk-stat-value', value));
    return d;
  }

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var seq;
      if (kind === 'ok') seq = [[523, 0], [659, 0.07]];
      else if (kind === 'win') seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[330, 0]];
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator();
        var g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g); g.connect(actx.destination);
        o.start(t + seq[i][1]); o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  function onVert(v) {
    if (S.ended) return;
    if (S.cur < 0) {
      if (v !== S.start) {
        renderNote('从高亮的起点（' + (S.start + 1) + ' 号点）出发——它连出的桥数是奇数，一笔画必须从奇点起笔。', '');
        return;
      }
      S.cur = v;
      sfx('sel');
      renderBoard();
      renderNote('站在 ' + (v + 1) + ' 号点。点一条连着的桥另一头的点，就走过去了。', '');
      return;
    }
    if (v === S.cur) return;
    var ei = edgeIndex(S.cur, v);
    if (ei < 0) {
      sfx('bad');
      renderNote((S.cur + 1) + ' 号和 ' + (v + 1) + ' 号之间没有桥——只能沿画出来的桥走。', 'bad');
      return;
    }
    if (S.walked[ei]) {
      sfx('bad');
      renderNote('这座桥已经走过了——每座桥恰好走一次。换别的桥，或点「撤销一步」退回来。', 'bad');
      return;
    }
    S.walked[ei] = 1;
    S.path.push({ v: v, e: ei });
    S.cur = v;
    sfx('ok');
    var done = S.walked.filter(Boolean).length;
    if (done === S.graph.E.length) {
      renderBoard();
      if (S.needBack && S.cur !== S.start) {
        S.ended = true;
        sfx('bad');
        ui.status.className = 'st-status is-over';
        ui.status.textContent = '所有桥都走完了，但终点在 ' + (S.cur + 1) + ' 号——这张图 0 个奇点，一笔画必须回到起点 ' + (S.start + 1) + ' 号。点「新开一局」再来。';
        renderNote('这就是回路和路径的区别：0 个奇点的图，起点即终点；2 个奇点的图，从一个奇点走到另一个。', 'bad');
        renderButtons();
        return;
      }
      winGame();
      return;
    }
    if (remainingDeg(S.graph, S.walked, S.cur) === 0) {
      sfx('bad');
      renderBoard();
      renderNote('卡住了：' + (S.cur + 1) + ' 号点的桥全走完了，但还有 ' + (S.graph.E.length - done) + ' 座没走。点「撤销一步」退回岔口——进去的桥和出来的桥要配对走，把奇点留给最后。', 'bad');
      return;
    }
    renderBoard();
    renderNote('走过一座桥到 ' + (S.cur + 1) + ' 号——还剩 ' + (S.graph.E.length - done) + ' 座。', '');
  }

  function undo() {
    if (S.ended || S.cur < 0) return;
    if (!S.path.length) {
      S.cur = -1;
      renderBoard();
      renderNote('已退回起点。想清楚再出发。', '');
      return;
    }
    var last = S.path.pop();
    S.walked[last.e] = 0;
    S.cur = S.path.length ? S.path[S.path.length - 1].v : S.start;
    sfx('sel');
    renderBoard();
    renderNote('退回到 ' + (S.cur + 1) + ' 号。换一条桥试试。', '');
  }

  function checkBoard() {
    if (S.ended) return;
    var g = S.graph;
    var odds = oddVerts(g);
    var deg = degrees(g);
    var head = '奇点定理：数每个点连出的桥数，奇数条的是奇点。这张图的奇点是 '
      + (odds.length ? odds.map(function (v) { return v + 1 + ' 号（' + deg[v] + ' 座桥）'; }).join('、') : '没有——每个点都连着偶数座桥')
      + '。' + (odds.length === 0
        ? '0 个奇点：从任意点出发都能把桥走完并回到起点。'
        : odds.length === 2
          ? '2 个奇点：必须从其中一个出发、在另一个结束——所以起点是 ' + (S.start + 1) + ' 号。'
          : '奇点多于 2 个，一笔画不出。');
    if (S.cur < 0) {
      renderNote(head + ' 现在还没出发——从高亮起点开始。', 'ok');
      return;
    }
    var rdeg = remainingDeg(g, S.walked, S.cur);
    var remOdd = remainingOdd(g, S.walked);
    var mid = '当前局面：你在 ' + (S.cur + 1) + ' 号，还连着 ' + rdeg + ' 座没走的桥'
      + (rdeg % 2 === 1 ? '（奇数——你正站在剩余路径的起点上，很好）' : '（偶数——从这里走完所有桥，最后会停在别的点）');
    var tail = '剩余图还有 ' + remOdd.length + ' 个奇度点（'
      + (remOdd.map(function (v) { return v + 1 + ' 号'; }).join('、') || '无') + '）。'
      + '口诀：进去的桥和出来的桥成对走，把奇数度的点留给路径两端。';
    renderNote(head + ' ' + mid + '。' + tail, 'ok');
  }

  function winGame() {
    S.ended = true;
    sfx('win');
    var rec = loadRecord();
    var key = 'x' + S.level;
    var cur = rec[key];
    if (!cur || typeof cur !== 'object' || Array.isArray(cur)) cur = { wins: 0 };
    cur.wins++;
    rec[key] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 隐私模式静默 */ }
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '一笔画成了！' + S.graph.E.length + ' 座桥每座恰好一次'
      + (S.needBack ? '，还回到了起点——欧拉回路。' : '——欧拉路径。') + '点「新开一局」换一张图。';
    renderNote('这就是柯尼斯堡七桥的答案：那 4 块陆地全是奇点（各连 3、5 座桥），怎么走都得重复过桥——欧拉 1736 年从这里开创了图论。', 'ok');
    renderRecord();
    renderButtons();
  }

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return r && typeof r === 'object' && !Array.isArray(r) ? r : {};
    } catch (e) { return {}; }
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderButtons();
      if (S.resetTimer) clearTimeout(S.resetTimer);
      S.resetTimer = setTimeout(function () { S.resetArm = false; S.resetTimer = null; renderButtons(); }, 3000);
      return;
    }
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    try { localStorage.removeItem(RECORD_KEY); } catch (e) { /* 隐私模式静默 */ }
    renderRecord();
    renderButtons();
    toast('已重置一笔画的本机成绩');
  }

  function renderButtons() {
    ui.resetBtn.classList.toggle('is-arm', S.resetArm);
    ui.resetBtn.textContent = S.resetArm ? '再点一次确认重置' : '重置成绩';
  }

  function save() {
    try {
      localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, level: S.level, soundOn: S.soundOn }));
    } catch (e) { /* 存储不可用静默 */ }
  }

  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (!d || d.v !== 1) return;
      if (d.level >= 0 && d.level < LEVELS.length) S.level = d.level;
      S.soundOn = d.soundOn !== false;
    } catch (e) { /* 忽略脏数据 */ }
  }

  function newGame(level) {
    var pool = GRAPHS[level];
    var g = pool[Math.floor(Math.random() * pool.length)];
    S.level = level;
    S.graph = g;
    S.start = g.start;
    S.cur = -1;
    S.walked = new Array(g.E.length).fill(0);
    S.path = [];
    S.needBack = !!g.back;
    S.ended = false;
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    syncLevels();
    buildBoard();
    renderRecord();
    renderButtons();
    renderNote('「' + g.name + '」：' + g.E.length + ' 座桥，从 ' + (g.start + 1) + ' 号点出发，每座桥恰好走一次'
      + (g.back ? '，走完还要回到起点。' : '。') + '点起点出发，点相邻的点过桥。', '');
    save();
  }

  function bindSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          for (var j = 0; j < btns.length; j++) {
            var on = btns[j] === b;
            btns[j].classList.toggle('is-active', on);
            btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
        });
      })(btns[i]);
    }
    syncSoundPicker();
  }

  function syncSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      var on = (btns[i].getAttribute('data-st-sound') === 'on') === S.soundOn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function toast(msg) {
    if (!ui.saved) return;
    ui.saved.textContent = msg;
    ui.saved.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { ui.saved.hidden = true; }, 2200);
  }

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.levels = root.querySelector('[data-st-yb-levels]');
    ui.svg = root.querySelector('[data-st-yb-svg]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.record = root.querySelector('[data-st-record]');
    ui.saved = root.querySelector('[data-st-saved]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.undoBtn = root.querySelector('[data-st-yb-undo]');
    ui.resetBtn = root.querySelector('[data-st-reset]');

    restorePrefs();
    renderLevels();
    bindSoundPicker();

    ui.newBtn.addEventListener('click', function () { newGame(S.level); });
    ui.checkBtn.addEventListener('click', checkBoard);
    ui.undoBtn.addEventListener('click', undo);
    ui.resetBtn.addEventListener('click', resetRecord);

    newGame(S.level);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STYibihua = {
    degrees: degrees,
    oddVerts: oddVerts,
    remainingOdd: remainingOdd,
    eulerOk: eulerOk,
    state: function () {
      return { graph: S.graph, cur: S.cur, start: S.start, walked: S.walked, needBack: S.needBack, ended: S.ended };
    }
  };
})(typeof window !== 'undefined' ? window : globalThis);
